/**
 * Module dependencies.
 */

import React from 'react';
import { Card } from '@tremor/react';
import { Title } from 'app/components/atoms/title/title';
import { useTranslation } from 'react-i18next';

/**
 * Export `MedicalInstrumentsOverview` component.
 */

export function MedicalInstrumentsOverview(): JSX.Element {
  const [translate] = useTranslation();

  return (
    <Card>
      <Title>{translate('users.overview.title')}</Title>
    </Card>
  );
}
